import PlayerStore from "@/store/player";
import CU from "@/utils/c-u";
import VkInsets from "@/utils/vk-insets";
import {IntegrationUtils} from "@/utils/integration-utils";

/**
 * Диагностика жалоб «низ интерфейса за экраном» и «чёрная полоса снизу».
 * Спорят три высоты: визуальный вьюпорт, layout-вьюпорт и то, что реально видит игрок
 * (VK на Android рисует окно под системными панелями). По строке из client_log видно,
 * какая из них верная у конкретного игрока - без этого правки остаются гаданием.
 *
 * Пишем только для VK и не больше пары строк за сессию.
 */
export default class ViewportReport {

    private static readonly MAX_PER_SESSION: number = 3;

    private static sent: number = 0;

    public static log(tag: string): void {
        if (!IntegrationUtils.isVkUser() || ViewportReport.sent >= ViewportReport.MAX_PER_SESSION) {
            return;
        }
        ViewportReport.sent++;
        try {
            PlayerStore.logClientError('VP ' + tag + ' ' + ViewportReport.compose()).catch(() => {});
        } catch (e) {
            // диагностика не должна ронять игру
        }
    }

    private static compose(): string {
        const vv = window.visualViewport;
        const canvas = document.getElementsByTagName('canvas').item(0);
        const doc = document.documentElement;

        return [
            'vv=' + Math.round(vv.width) + 'x' + Math.round(vv.height)
                + '@' + Math.round(vv.offsetTop) + '/' + vv.scale,
            'inner=' + window.innerWidth + 'x' + window.innerHeight,
            'client=' + (doc ? doc.clientWidth + 'x' + doc.clientHeight : '-'),
            'screen=' + window.screen.width + 'x' + window.screen.height,
            'dpr=' + window.devicePixelRatio,
            'css=' + CU.CSS_WIDTH + 'x' + CU.CSS_HEIGHT,
            'canv=' + CU.CANVAS_WIDTH + 'x' + CU.CANVAS_HEIGHT,
            'style=' + (canvas ? canvas.style.width + 'x' + canvas.style.height : '-'),
            'insetBottom=' + VkInsets.getBottomCss(vv.height),
            'vk=' + VkInsets.describe(),
        ].join(' | ');
    }
}
